import { useContext } from "react"
import { AuthContext } from "../contexts/authContext"
import { Navigate } from "react-router-dom"
import { Confirm } from "./confirm";

const PrivateRoute = ({children}) => {
    
    const { loading, user } = useContext(AuthContext);
    if (loading) {
        return <span className="loading loading-dots loading-lg"></span>;
      }
    
      if (user) {
        if (user.emailVerified) {
          return children;
        }
        else
        {
          return <Confirm/>
        }
      }
    
      return <Navigate to="/login" />;
}

export default PrivateRoute